import React from 'react';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';
import './styles/Products.css';

const Products = () => {
  // Sample products - replace with actual products
  const products = [
    {
      id: 1,
      name: 'Curcuma Zedoary',
      description: 'High quality product with excellent features and durability. Perfect for various applications.',
      image: '/images/curcuma_zedoaria.jpeg',
      //category: 'Category A'
    },
    {
      id: 2,
      name: 'Aswagandha Roots',
      description: 'Premium quality product designed to meet your specific needs. Reliable and efficient.',
      image: '/images/aswagandha_roots.jpeg',
     // category: 'Category B'
    },
    {
      id: 3,
      name: 'Marathi Moggu',
      description: 'Durable and reliable product solution with modern design and advanced features.',
      image: '/images/marathi_moggu.jpeg',
      //category: 'Category A'
    },
    {
      id: 4,
      name: 'Chia Seeds',
      description: 'Innovative product with modern design and cutting-edge technology for superior performance.',
      image: '/images/chia_seeds.jpeg',
      //category: 'Category B'
    },
    {
      id: 5,
      name: 'Garlic',
      description: 'High-quality product with excellent build quality and outstanding customer reviews.',
      image: '/images/garlic.jpg',
      //category: 'Category C'
    },
    {
      id: 6,
      name: 'Turmeric',
      description: 'Premium product solution with advanced features and reliable performance guarantee.',
      image: '/images/turmeric.jpg',
      //category: 'Category C'
    }
  ];

  return (
    <>
      <Helmet>
        <title>Products - SARKAR TRADERS</title>
        <meta name="description" content="Browse our wide range of quality products at SARKAR TRADERS. Find the perfect product for your needs." />
      </Helmet>
      
      <div className="products-page">
        <div className="container">
          <h1>Our Products</h1>
          <p className="products-intro">
            We offer a wide range of high-quality products to meet your diverse needs. 
            Browse through our collection and find the perfect product for you.
          </p>
          
          <div className="products-grid">
            {products.map((product) => (
              <div key={product.id} id={`product-${product.id}`} className="product-card">
                <div className="product-image">
                  <img src={product.image} alt={product.name} />
                </div>
                <div className="product-info">
                  <span className="product-category">{product.category}</span>
                  <h3>{product.name}</h3>
                  <p>{product.description}</p>
                  <div className="product-actions">
                    <Link to="/contact" className="product-btn">
                      Inquire Now
                    </Link>
                  </div>
                </div>
              </div>
            ))}
          </div>
          
          <div className="contact-cta">
            <p>Interested in our products? Contact us for more information!</p>
            <Link to="/contact" className="cta-btn">
              Get in Touch
            </Link>
          </div>
        </div>
      </div>
    </>
  );
};

export default Products;




